import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, map} from "rxjs/operators";
import {empty} from "rxjs/observable/empty";
import {Observable} from "rxjs/Observable";

export interface MaintenanceData {
  maintenance: boolean;
  message?: string;
  start_time?: Date;
  approx_end_time?: Date;
}

@Injectable()
export class MaintenanceService {

  constructor(private router: Router, private http: HttpClient) {
  }

  public getMaintenanceStatus(): Observable<MaintenanceData> {
    return this.http.get(environment.baseUrl + '/api/check-maintenance', {observe: 'response'}).pipe(
      map<any, MaintenanceData>(res => res.body),
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 503) {
          console.warn("API is in maintenance mode...");
          return empty<MaintenanceData>();
        }
        throw err;
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/maintenance/maintenance.service.ts